import { Pipe, PipeTransform } from '@angular/core';
import { BeneficiaryDetailsChanges } from '../../beneficiaries/models/beneficiary-details-changes';

@Pipe({
  name: 'previousNotApplicable',
  standalone: true
})
export class PreviousNotApplicablePipe implements PipeTransform {
  transform(value: BeneficiaryDetailsChanges | null): boolean {
    if (!!value) {
      return value.new.length > 0 && !value.previous.length;
    } else {
      return false;
    }
  }
}
